export default "__VITE_ASSET__CY4G1Mbl__"